var map = {
	"./A.png": "7e94",
	"./B.png": "7952",
	"./C.png": "81bf",
	"./D.png": "ffbf",
	"./ZW.png": "427d",
	"./bg1.png": "756d",
	"./core.png": "9dea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";